import { useContext } from "react";
import {
  ShipmentConfirmContextValue,
  ShipmentDeleteContextValue,
  ShipmentDetailsContextValue,
} from "./types";
import {
  ShipmentConfirmContext,
  ShipmentDeleteContext,
  ShipmentDetailsContext,
} from "./contexts";

/* ===========================================================================
 * CUSTOM HOOK: useShipmentDetailsContext
 * ======================================================================== */

/*
  Retrieves the value of ShipmentDetailsContext.
  Must be used within a ShipmentDetailsProvider.
  Throws an error if used outside its provider.
 */
export const useShipmentDetailsContext = (): ShipmentDetailsContextValue => {
  const context = useContext(ShipmentDetailsContext);
  if (!context) {
    throw new Error("useDetailsContext must be used within an DetailsProvider");
  }
  return context;
};

/* ===========================================================================
 * CUSTOM HOOK: useShipmentDeleteContext
 * ======================================================================== */

/*
  Retrieves the value of ShipmentDeleteContext.
  Must be used within a ShipmentDeleteProvider.
  Throws an error if used outside its provider.
  */
export const useShipmentDeleteContext = (): ShipmentDeleteContextValue => {
  const context = useContext(ShipmentDeleteContext);
  if (!context) {
    throw new Error(
      "useDeleteShipmentContext must be used within a DeleteShipmentProvider",
    );
  }
  return context;
};

/* ===========================================================================
 * CUSTOM HOOK: useShipmentConfirmContext
 * ======================================================================== */

/*
  Retrieves the value of ShipmentConfirmContext.
  Must be used within a ShipmentConfirmProvider.
  Throws an error if used outside its provider.
*/
export const useShipmentConfirmContext = (): ShipmentConfirmContextValue => {
  const context = useContext(ShipmentConfirmContext);
  if (!context) {
    throw new Error(
      "useConfirmShipmentContext must be used within a ConfirmShipmentProvider",
    );
  }
  return context;
};
